import React, { useEffect, useState } from 'react';
import ReviewCard from './ReviewCard';
import ReviewElement from './ReviewElement';
import '../style/reviewsContent.css';

import { getReviewsAd } from '../../../api/get/getReviewsAd';
import getAnnauncementById from '../../../api/getAnnouncementById';

const ReviewsContent = ({ id }) => {
    const [reviews, setReviews] = useState([]);
    const [announcement, setAnnouncement] = useState(null);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await getReviewsAd({ id });
                setReviews(data);
            } catch (error) {
                console.error("Пікірлерді жүктеу кезінде қате:", error);
            }
        };

        const fetchAnnouncement = async () => {
            try {
                const data = await getAnnauncementById(id);
                setAnnouncement(data.announcement);
            } catch (error) {
                console.error("Ошибка загрузки объявления:", error);
            }
        };

        if (id) {
            fetchReviews();
            fetchAnnouncement();
        }
    }, [id]);

    return (
        <div className="reviews-container">
            <div className="reviews-left">
                {reviews.map((review, index) => (
                    <ReviewCard key={index} {...review} />
                ))}
            </div>
            <div className="reviews-right">
                {announcement && <ReviewElement {...announcement} />}
            </div>
        </div>
    );
};

export default ReviewsContent;